module.exports = __webpack_public_path__ + "img/payment-icons.c1ce64b7.png";